import { createRouter, createWebHashHistory } from 'vue-router'

/**
 * Route meta conventions:
 *   meta.title  — page <title> (display name)
 *   meta.public — true means route does NOT require auth
 *
 * Backward-compat: legacy `meta.name` / `meta.nacy === 'true'` are honored by
 * the beforeEach guard in main.js during the migration period.
 */
const routes = [
  // Root → Home (no separate /home entry; redirect handled below)
  {
    path: '/home',
    name: 'home',
    meta: { title: '首页', tabbar: true },
    component: () => import('../views/home'),
  },
  {
    path: '/',
    redirect: '/home',
  },

  // Auth (public)
  {
    path: '/login',
    name: 'login',
    meta: { title: '登录', public: true },
    component: () => import('../views/login'),
  },
  {
    path: '/register',
    name: 'register',
    meta: { title: '注册', public: true },
    component: () => import('../views/register'),
  },
  {
    path: '/findpwd',
    name: 'findpwd',
    meta: { title: '找回密码', public: true },
    component: () => import('../views/findpwd'),
  },

  // Main tabs
  {
    path: '/history',
    name: 'history',
    meta: { title: '兑换记录', tabbar: true },
    component: () => import('../views/history'),
  },
  {
    path: '/point',
    name: 'point',
    meta: { title: '获取积分', tabbar: true },
    component: () => import('../views/point'),
  },
  {
    path: '/mine',
    name: 'mine',
    meta: { title: '我的', tabbar: true },
    component: () => import('../views/mine'),
  },

  // Secondary pages
  {
    path: '/exchange',
    name: 'exchange',
    meta: { title: '兑换积分' },
    component: () => import('../views/point/exchange'),
  },
  {
    path: '/invite',
    name: 'invite',
    meta: { title: '邀请好友' },
    component: () => import('../views/point/invite'),
  },
  {
    path: '/search',
    name: 'search',
    meta: { title: '搜索' },
    component: () => import('../views/search'),
  },
  {
    path: '/detail',
    name: 'detail',
    meta: { title: '详情' },
    component: () => import('../views/detail'),
  },
  {
    path: '/buy',
    name: 'buy',
    meta: { title: '购买积分' },
    component: () => import('../views/buy'),
  },
  {
    path: '/trades',
    name: 'trades',
    meta: { title: '积分记录' },
    component: () => import('../views/trades'),
  },
  {
    path: '/tutorial',
    name: 'tutorial',
    meta: { title: '使用教程', public: true },
    component: () => import('../views/tutorial'),
  },

  // Settings
  {
    path: '/setting',
    name: 'setting',
    meta: { title: '账号设置' },
    component: () => import('../views/mine/setting'),
  },
  {
    path: '/resetname',
    name: 'resetname',
    meta: { title: '修改昵称' },
    component: () => import('../views/mine/reset/resetname'),
  },
  {
    path: '/resetpwd',
    name: 'resetpwd',
    meta: { title: '修改密码' },
    component: () => import('../views/mine/reset/resetpwd'),
  },

  // Misc
  {
    path: '/fanghong',
    name: 'fanghong',
    meta: { title: '请在浏览器打开', public: true },
    component: () => import('../views/fanghong'),
  },
  {
    path: '/shareid',
    name: 'share',
    meta: { title: '分享', public: true },
    component: () => import('../views/share'),
  },

  // 404 catch-all (was missing)
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    meta: { title: '页面不存在', public: true },
    component: () => import('../views/home'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    return { top: 0 }
  },
})

export default router
